import { render, staticRenderFns } from "./DataCheckInfo.vue?vue&type=template&id=6deea2ce&scoped=true&"
import script from "./DataCheckInfo.vue?vue&type=script&lang=js&"
export * from "./DataCheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./DataCheckInfo.vue?vue&type=style&index=0&id=6deea2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deea2ce",
  null
  
)

export default component.exports